// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const token = 'yKsJkEPpq9FKXwVZnXF2nk9ahzoeS0Hj';

function getBaseUrl(): string {
  const hostname = window.location.hostname;
  if (hostname === 'restaurant.theranch.ma') {
    return 'https://pos.theranch.ma';
  }
  if (hostname === 'restaurant.aglioeolio.ma') {
    return 'https://order.aglioeolio.ma';
  }
  // fallback: localhost
  return 'http://localhost:94/app_dev.php';
}

function getAppName(): string {
  const hostname = window.location.hostname;
  if (hostname === 'restaurant.aglioeolio.ma') {
    return 'Aglio e Olio';
  }
  return 'The Ranch';
}

function getLogo(): string {
  const hostname = window.location.hostname;
  if (hostname === 'restaurant.aglioeolio.ma') {
    return 'assets/logo-aglio.png';
  }
  return 'assets/logo.png';
}

function getApiUrl(): string {

  return getBaseUrl() + '/restaurant-api/' + token;
}

function getOneSignalApi(): string {

  return getBaseUrl() + '/api/notifications';
}

export const environment = {
  production: false,
  token: token,
  url: getApiUrl(),
  urlImg: getBaseUrl(),
  appName: getAppName(),
  logo: getLogo(),
  oneSignalAppId: 'c715a9fa-c58e-468e-b900-bb91c1edce01',
  oneSignalApi: getOneSignalApi(),
  version: '0.0.3'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
